import React from "react";
import {Box, useColorMode, Skeleton} from "@chakra-ui/react";

const OsLoadingCard = () => {
  const {colorMode} = useColorMode();

  return (
    <Box borderRadius="3px" padding="15px" borderWidth="1px" borderColor={colorMode === "light" ? "gray.300" : "gray.600"}>
      <Box borderColor={colorMode === "light" ? "gray.300" : "gray.600"} borderBottomWidth="1px" paddingBottom="10px">
        <Skeleton minHeight="120px" />
      </Box>
      <Box paddingTop="10px">
        <Skeleton minHeight="40px" />
      </Box>
    </Box>
  );
};

export default OsLoadingCard;
